import React, { useEffect, useState } from 'react';
import FooterNav from 'components/ui/footerNav';
import HeaderBackCta from 'components/ui/headerBackCta';
import NoDataFound from 'components/ui/noDataFound';
import SelectionCard from 'components/ui/selectionCard';
import ToastMessage from 'components/ui/toastMessage';
import TeamNameOverlay from 'components/ui/teamNameOverlay';
import SelectTeamOverlay from 'components/ui/overlaySelectedTeam';
import MatchCard from '../matchCard';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  getCookie,
  getPlayersFromLocalStorage,
  savePlayersToLocalStorage,
  setCookie,
  isWebView,
  areArraysEqual
} from 'utils/commonFunctions';
import config from 'utils/config';
import {
  Api,
  useCreateTeamMutation,
  useGetGamerCardQuery,
  useGetTeamCreatedGamedaysQuery,
  useGetTeamNameValidateMutation,
  useGetUserCreatedTeamQuery,
  useGetUserPhaseWisePlayersQuery
} from 'api';
import { useDispatch, useSelector } from 'react-redux';
// import { showTeamNameOverlay } from 'store/slice/overlaySlice';
import { useMsal } from '@azure/msal-react';
import { useConstraintsQuery, useFixturesQuery, usePlayerListsQuery } from 'api/feeds';
import { OPEN_MATCH_STATUS, retValMessages } from 'utils/constants';
import { handlePlayerInfoOverlay } from 'store/slice/overlaySlice';
import OverlayPlayerList from '../overlayPlayerList';
import { playerSelection } from 'store/slice/createTeamSlice';
import PlayerCardOverlay from '../playerCardOverlay';
import Loader from '../loader';
import DiscardTeamOverlay from 'components/discardTeamOverlay';
import { set } from 'store';
import Button from '../button';
import MatchCardInfo from '../matchCardInfo';
import { setToastMessage, closeToast } from 'store/slice/toastMessageSlice';

const CreateTeam = () => {
  const gameCookie = getCookie(config.gameCookieName);
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [openToast, setOpenToast] = useState(false);
  const fixturedata = useSelector((state) => state.createTeam.gameFixtures);
  // const { data: fixturedata, error: fixtureError, isLoading: fixtureLoading } = useFixturesQuery();
  const [teamError, setTeamError] = useState(null);
  const matchesData = fixturedata;
  //const isUserLoggedIn = useSelector((state) => state.login.isUserLoggedIn);
  const [discardTeam, setDiscardTeam] = useState(false);

  const filteredEvents = matchesData?.filter(
    (event) => event.event_status_id === OPEN_MATCH_STATUS
  );
  const location = useLocation();
  const matchData = location.state?.match;
  const openEvent = filteredEvents?.length > 0 ? matchData : null;

  const handleDiscardTeamOverlay = (flag) => {
    setDiscardTeam(flag);
  };

  const {
    data: gamedaydata,
    error: gamedayerror,
    isLoading: gamedaydataisLoading
  } = useGetTeamCreatedGamedaysQuery(
    { guid: gameCookie?.guid, gamedayId: openEvent?.gameday_id },
    { skip: !gameCookie?.guid, refetchOnMountOrArgChange: true }
  );

  const [showTeamNamePopup, setShowTeamNamePopup] = useState({
    flag: false,
    teamName: '',
    errMsg: '',
    charCount: 0
  });

  const [showOverlaySelectedTeam, setShowOverlaySelectedTeam] = useState(false);
  const selectedPlayers = useSelector((state) => state?.createTeam?.selectedPlayers || []);
  const dispatch = useDispatch();

  const [getteamData, { data: teamData, teamDatagamedayerror, teamDatasLoading }] =
    Api.endpoints.getUserCreatedTeam.useLazyQuery();

  const {
    data: Phaseplayerdata,
    error: playerError,
    isLoading: playerIsLoading
  } = useGetUserPhaseWisePlayersQuery(
    { guid: gameCookie?.guid },
    { skip: !gameCookie?.guid, refetchOnMountOrArgChange: true }
  );

  const phaseData = Phaseplayerdata?.Data?.Value?.phase_players?.find(
    (phase) => phase.phase_id === 2 || phase.phase_id === 1
  );

  const {
    data: Constraint,
    error: ConstraintsError,
    isLoading: ConstraintsLoading
  } = useConstraintsQuery();

  if (ConstraintsError || PlayerError) {
    return (
      <div>
        <Loader />
      </div>
    );
  }
  const ConstraintsData = Constraint?.Data?.Value;
  const skillsArray = ConstraintsData?.composition_skills || [];

  const showPlayerListOverlay = useSelector((state) => state?.overlay.showPlayerListOverlay);
  const playerInfoOverlayVisible = useSelector((state) => state.overlay.playerInfoOverlayVisible);

  // const skillroles = skillsArray.map((constraint) => constraint.skill_name);
  const skillroles = ['BATTER', 'BOWLER', 'ALL ROUNDER'];

  useEffect(() => {
    if (gameCookie?.guid) {
      getteamData({
        guid: gameCookie?.guid,
        gamedayId: activeGamedayId
      });

      if (
        !getCookie(config.gameCookieName)?.team_name &&
        localStorage.getItem('preLoginRoute') === '/createteam'
      ) {
        setShowTeamNamePopup((prev) => ({ ...prev, flag: true }));
      }
    }
  }, [gameCookie?.guid]);

  useEffect(() => {
    if (teamData) {
      const hasPlayers = teamData?.Data?.Value?.gameday_player_ids?.length > 0;

      if (hasPlayers && localStorage.getItem('preLoginRoute') === '/createteam') {
        setShowOverlaySelectedTeam(true);
        localStorage.removeItem('preLoginRoute');
      } else if (!hasPlayers && localStorage.getItem('preLoginRoute') === '/createteam') {
        localStorage.removeItem('preLoginRoute');
      }
    }
  }, [teamData]);

  const handleToastMessage = (open, message, type) => {
    dispatch(setToastMessage({ toastMessageState: { open: open, message: message, type: type } }));
  };

  const handleRedirect = async () => {
    localStorage.setItem('preLoginRoute', location.pathname);
    localStorage.setItem('matchgameid', matchgameid);
    // localStorage.setItem('openEvent', JSON.stringify(openEvent) || '');
    if (isWebView() && !window?.standaloneTopPicks?.isLoggedIn()) {
      // WebView login flow
      if (window?.standaloneTopPicks?.logIn) {
        window?.standaloneTopPicks?.logIn();
      } else {
        console.error('WebView login function not available');
      }
    } else {
      let loginRequest = {
        scopes: [
          'openid',
          'offline_access',
          config.envMsalAzureFlag
            ? 'https://accounts.icc-cricket.com/api/catalogue.read'
            : 'https://iccdevlogin.onmicrosoft.com/api/catalogue.read'
        ]
      };

      try {
        await instance.loginRedirect(loginRequest);
      } catch (error) {
        console.log('Sign in error:', error);
      }
    }
  };

  const toggleTeamNamePopup = () => {
    if (!matchgameid) {
      setShowTeamNamePopup((prev) => ({ ...prev, flag: !prev.flag }));
    }
  };

  // const handlePlayerSelection = (selectedPlayer) => {
  //   dispatch(playerSelection({ ply: selectedPlayer }));
  //   dispatch(handlePlayerInfoOverlay(false)); // Close overlay after selection
  // };

  useEffect(() => {
    if (!teamData?.Data?.Value || teamData?.Data?.Value?.gameday_player_ids?.length === 0) {
      const storedPlayers = getPlayersFromLocalStorage(activeGamedayId) || [];
      if (storedPlayers.length > 0) {
        console.log('Using data from localStorage as teamData is empty');
      }
    }
  }, [teamData]);

  const handleSaveSelection = async () => {
    const gameCookie = getCookie(config.gameCookieName);
    //  localStorage.setItem('selectedPlayers', JSON.stringify(selectedPlayers));
    savePlayersToLocalStorage(activeGamedayId, selectedPlayers);
    // if (selectedPlayers.length !== 3) {
    //   showToastMessage('Please select all players before saving!');
    //   return;
    // }

    // Step 1: Redirect if user is not logged in
    if (!gameCookie?.guid) {
      await handleRedirect();
      return;
    }
    // Step 2: Check if `team_name` exists in cookie
    if (!gameCookie?.team_name) {
      setShowTeamNamePopup((prev) => ({ ...prev, flag: true }));
    } else {
      handlesaveteam();
    }
  };

  // Toast message handler
  // const showToastMessage = (message) => {
  //   setOpenToast(true);
  //   setTimeout(() => {
  //     setOpenToast(false);
  //   }, 3000); // Auto-hide after 3 seconds
  // };

  const handleTeamNameChange = (e) => {
    let value = e.target.value;
    let specialCharRegex = /[^a-zA-Z0-9 ]/g; // Detect special characters
    let emojiRegex =
      /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1F018}-\u{1F270}\u{1F300}-\u{1F5FF}\u{FE00}-\u{FE0F}\u{1F900}-\u{1F9FF}\u{1F600}-\u{1F64F}\u{2702}\u{27B0}\u{1F680}-\u{1F6C0}\u{24C2}\u{1F170}-\u{1F251}\u{1F600}-\u{1F636}\u{1F681}-\u{1F6C5}\u{1F30D}-\u{1F567}]/gu;

    let leagueNameError = '';
    value = value.replace(/^\s+/, '');

    const charCount = value.length;
    if (charCount > 25) {
      leagueNameError = 'Max 25 characters are allowed';
    } else if (charCount < 3) {
      leagueNameError = 'Min 3 characters are allowed';
    } else if (emojiRegex.test(value)) {
      leagueNameError = 'Emoji is not allowed.';
    } else if (specialCharRegex.test(value)) {
      leagueNameError = 'Special characters are not allowed';
    }

    setShowTeamNamePopup({
      ...showTeamNamePopup,
      teamName: value,
      errMsg: leagueNameError,
      charCount: charCount
    });
  };

  const [submitPrediction, { isLoading, isError, isSuccess, error }] = useCreateTeamMutation();
  // Get stored event safely
  const storedEvent = localStorage.getItem('openEvent');
  const parsedStoredEvent = JSON.parse(storedEvent);

  // Store `openEvent` only if it exists, otherwise remove it
  useEffect(() => {
    if (openEvent) {
      localStorage.setItem('openEvent', JSON.stringify(openEvent));
    }
    // return () => {
    //   console.log('openEvent removed from localStorage');
    //   localStorage.removeItem('openEvent');
    // };
  }, [openEvent]);

  // Determine the active game day ID
  const activeGamedayId = openEvent?.gameday_id || parsedStoredEvent?.gameday_id || null;
  const matchgameid = gamedaydata?.Data?.Value?.team_gameday_ids.includes(activeGamedayId);
  const {
    data: playerlistdata,
    error: PlayerError,
    isLoading: PlayerLoading
  } = usePlayerListsQuery(
    { gamedayId: parsedStoredEvent?.gameday_id },
    { skip: !gameCookie?.guid || !parsedStoredEvent?.gameday_id }
  );
  const playerList = playerlistdata?.Data?.Value?.Players || [];
  const [teamnamedata, { Loading, Error }] = useGetTeamNameValidateMutation();
  const handlesaveteam = async () => {
    try {
      const teamName = showTeamNamePopup?.teamName;
      if (!gameCookie?.team_name) {
        if (showTeamNamePopup?.teamName) {
          const validationResponse = await teamnamedata({
            guid: gameCookie?.guid,
            teamName
          }).unwrap();

          if (validationResponse?.Data?.Value === 0) {
            setShowTeamNamePopup((prev) => ({
              ...prev,
              errMsg: 'Team name already exists. Please choose another one.'
            }));
            return;
          }

          if (validationResponse?.Data?.Value === -1) {
            setShowTeamNamePopup((prev) => ({
              ...prev,
              errMsg: 'Something went wrong. Please try again later.'
            }));
            return;
          }
        }
      }
      if (!gameCookie?.guid) {
        await handleRedirect();
      }

      // const storedPlayers = JSON.parse(localStorage.getItem('selectedPlayers')) || [];
      const storedPlayers = getPlayersFromLocalStorage(activeGamedayId);
      const payload = {
        optType: matchgameid ? 2 : 1,
        clientId: 1,
        gameDayId: activeGamedayId,
        playersIds: storedPlayers.map((p) => p.id),
        playerSkills: storedPlayers.map((p) => p.skill_id),
        platformId: 1,
        teamName: showTeamNamePopup?.teamName || gameCookie?.team_name
      };

      const response = await submitPrediction(payload).unwrap();

      if (response?.Meta?.RetVal == 1) {
        handleSuccess(response);

        localStorage.removeItem('selectedPlayers');
        localStorage.removeItem('openEvent');
        localStorage.removeItem('guestTeams');
        localStorage.removeItem('preLoginRoute');
        if (!matchgameid) {
          const updatedGameCookie = {
            ...gameCookie,
            team_name: showTeamNamePopup?.teamName || gameCookie.team_name
          };

          updatedGameCookie.game_session_token = response?.Data?.Value?.game_session_token;

          setCookie(config.gameCookieName, JSON.stringify(updatedGameCookie));
          setShowTeamNamePopup((prev) => ({ ...prev, flag: true }));
        }

        navigate('/');
      } else {
        handleFailure(response);
      }
    } catch (err) {
      console.error('Error during team name validation or submission:', err);
      handleFailure(err);
    }
  };
  const storedPlayers = JSON.parse(localStorage.getItem('selectedPlayers')) || [];

  const handleFailure = (response) => {
    const retVal = response?.Meta?.RetVal;
    const message = retValMessages?.createTeam[retVal] || 'Something went wrong. Please try again.';

    handleToastMessage(true, message, 2);
  };

  const handleSuccess = (response) => {
    const retVal = response?.Meta?.RetVal;
    const message = retValMessages?.success[retVal] || 'Team saved successfully.';

    handleToastMessage(true, message, 1);
  };

  useEffect(() => {
    const userTeamData =
      teamData?.Data?.Value?.gameday_player_ids?.length > 0
        ? teamData
        : getPlayersFromLocalStorage(activeGamedayId);

    if (userTeamData?.Data?.Value?.gameday_player_ids?.length > 0) {
      dispatch(playerSelection({ ply: [] }));

      const preselectedPlayers = userTeamData.Data.Value.gameday_player_ids.map(
        (teamPlayerId, index) => {
          const skillId = userTeamData.Data.Value.gameday_player_skills[index];
          const matchedPlayer = playerList.find(
            (player) => player.id === teamPlayerId && player.skill_id === skillId
          );

          return matchedPlayer || { id: teamPlayerId, skill_id: skillId };
        }
      );

      dispatch(playerSelection({ ply: preselectedPlayers }));
    } else {
      // Try getting players from localStorage if userTeamData is empty
      // const storedPlayers = JSON.parse(localStorage.getItem('selectedPlayers')) || [];
      const storedPlayers = getPlayersFromLocalStorage(activeGamedayId);
      if (storedPlayers.length > 0) {
        dispatch(playerSelection({ ply: storedPlayers }));
      } else {
        dispatch(playerSelection({ ply: [] })); // Clear state
      }
    }
  }, [teamData, playerlistdata, dispatch]);

  const selectedPlayerId = [...new Set(selectedPlayers?.map((player) => player?.id))];
  const playersIdFromApi = teamData?.Data?.Value?.gameday_player_ids || [];

  const handleBack = () => {
    if (areArraysEqual(selectedPlayerId, playersIdFromApi)) {
      navigate('/');
    } else {
      handleDiscardTeamOverlay(true);
    }
  };

  return (
    <>
      <div className='si-layoutBuilder__container'>
        <div className='si-main__container'>
          <div className='si-layoutBuilder__grid'>
            <div className='si-layoutBuilder__grid-lhs si-createTeamBg si-layoutBuilder__grid-lhs--botNav'>
              <div className='si-header__head'>
                <div className='si-backBtn'>
                  <Button
                    variant={`primaryLink`}
                    onClick={() => handleBack()}
                    transKey={'cta_backToHome'}
                    icon={'lms-back'}
                    leadingIcon={true}
                  >
                    {'Back to Home'}
                  </Button>
                </div>
              </div>
              <div className='si-matchCardList si-matchCardList--createTeam '>
                <MatchCard
                  showCTA={false}
                  openEvent={parsedStoredEvent}
                  hideTimer={false}
                  matchesData={parsedStoredEvent ? [parsedStoredEvent] : []}
                  showPostCard={true}
                  totalGdPoints={teamData?.Data?.Value?.gameday_points}
                  lateOnboard={teamData?.Data?.Value?.is_late_onboarded_user}
                  matchgameid={matchgameid}
                />
              </div>

              {parsedStoredEvent?.phase_id === 1 &&
              (Number(parsedStoredEvent?.event_status_id) === 1 ||
                (Number(parsedStoredEvent?.event_status_id) === 2 && !matchgameid)) ? (
                <div className='si-notification__fixed'>
                  <ToastMessage
                    open={true}
                    type={3}
                    transMessage={'pick_player_lock'}
                    message={'Picked players are locked until knockout stages.'}
                  />
                </div>
              ) : parsedStoredEvent?.phase_id === 2 &&
                (Number(parsedStoredEvent?.event_status_id) === 1 ||
                  (Number(parsedStoredEvent?.event_status_id) === 2 && !matchgameid)) ? (
                <div className='si-notification__fixed'>
                  <ToastMessage
                    open={true}
                    type={3}
                    transMessage={'pick_player_lock_finals'}
                    message={'Picked players are locked until the final concludes.'}
                  />
                </div>
              ) : null}

              <div className='si-selectionCard__list'>
                <SelectionCard
                  matchDetails={parsedStoredEvent}
                  userTeamData={
                    teamData?.Data?.Value?.gameday_player_ids?.length > 0
                      ? teamData
                      : getPlayersFromLocalStorage(activeGamedayId)
                  }
                  teamData={playersIdFromApi}
                  openEvent={parsedStoredEvent}
                  matchgameid={matchgameid}
                />
              </div>

              {parsedStoredEvent?.event_status_id == 2 &&
              !parsedStoredEvent?.is_final_locked &&
              !matchgameid ? (
                <div className='si-notification__fixed'>
                  <ToastMessage
                    open={true}
                    type={5}
                    transMessage={'match_card_game_is_live_pick_your_players_with_reduced_points'}
                    message={'*Game is Live, Pick your players with reduced points'}
                  />
                </div>
              ) : null}

              {teamData?.Data?.Value?.is_late_onboarded_user ? (
                <div className='si-notification__fixed'>
                  <ToastMessage
                    open={true}
                    type={5}
                    transMessage={'lateonboarded_score'}
                    message={
                      'This was a late onboard team, so the score is 90% of the total XXX × 0.90 = XXX points).'
                    }
                  />
                </div>
              ) : null}

              {showOverlaySelectedTeam && (
                <SelectTeamOverlay
                  show={showOverlaySelectedTeam}
                  onClose={() => {
                    setShowOverlaySelectedTeam(false);
                    localStorage.removeItem('guestTeams');
                    localStorage.removeItem('preLoginRoute');

                    navigate('/');
                  }}
                  errorMessage={teamError}
                />
              )}

              {showTeamNamePopup.flag ? (
                <TeamNameOverlay
                  closeOverlay={toggleTeamNamePopup}
                  handleTeamNameChange={handleTeamNameChange}
                  setShowTeamNamePopup={setShowTeamNamePopup}
                  showTeamNamePopup={showTeamNamePopup}
                  handlesaveteam={handlesaveteam}
                />
              ) : null}
              {parsedStoredEvent?.event_status_id == 1 && !showPlayerListOverlay ? (
                <FooterNav
                  openEvent={openEvent}
                  selectplayer={true}
                  handleSaveSelection={handleSaveSelection}
                  selectedPlayerId={selectedPlayerId}
                  playersIdFromApi={playersIdFromApi}
                  matchgameid={matchgameid}
                />
              ) : parsedStoredEvent?.event_status_id == 2 &&
                !matchgameid &&
                !showPlayerListOverlay ? (
                <FooterNav
                  openEvent={openEvent}
                  selectplayer={true}
                  handleSaveSelection={handleSaveSelection}
                  selectedPlayerId={selectedPlayerId}
                  playersIdFromApi={playersIdFromApi}
                  matchgameid={matchgameid}
                />
              ) : null}
            </div>

            <div
              className={`si-layoutBuilder__grid-rhs ${showPlayerListOverlay ? 'si-active' : ''}`}
            >
              <div className='si-pitchView'>
                {showPlayerListOverlay && (
                  <OverlayPlayerList
                    bodyScroll={true}
                    skillroles={skillroles}
                    onCancel={() => dispatch(handlePlayerInfoOverlay(false))}
                    onConfirm={(selectedPlayer) => {
                      dispatch(playerSelection({ ply: selectedPlayer }));
                      dispatch(handlePlayerInfoOverlay(false));
                    }}
                    matchDetails={parsedStoredEvent}
                    phaseData={phaseData}
                    playerPhaseData={Phaseplayerdata?.Data?.Value?.phase_players}
                    playersIdFromApi={playersIdFromApi}
                    selectedPlayerId={selectedPlayerId}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {playerInfoOverlayVisible && <PlayerCardOverlay />}
      {discardTeam && <DiscardTeamOverlay handleDiscardTeamOverlay={handleDiscardTeamOverlay} />}
    </>
  );
};

export default CreateTeam;
